import { render } from "./LatestNews.vue?vue&type=template&id=9888fbc4"
import script from "./LatestNews.vue?vue&type=script&lang=js"
export * from "./LatestNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__